'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoChatbubble = function IoChatbubble(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 35.1c-9 0-16.3-7-16.3-15.6s7.3-15.7 16.3-15.7 16.2 7 16.2 15.7c0 3.1-0.9 6-2.6 8.4-0.1 0.1-0.1 0.2-0.2 0.3-0.2 0.3-0.3 0.8-0.3 1.2l1.7 6.9-6.6-2.5c-0.3-0.1-0.6-0.1-0.9-0.1s-0.6 0.1-0.9 0.1c0 0 0 0.1-0.1 0.1-2 0.8-4.1 1.2-6.3 1.2z' })
        )
    );
};

exports.default = IoChatbubble;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/chatbubble.js
// module id = 2463
// module chunks = 168707334958949